// extracted by mini-css-extract-plugin
export default {"bell-icon":"CampaignPopUp_bell-icon__Ztu+N","title":"CampaignPopUp_title__oUEsX","alert":"CampaignPopUp_alert__iwQsh","close-btn":"CampaignPopUp_close-btn__X9PGS"};